// extracted by mini-css-extract-plugin
export var barContainer = "_2w-0";
export var extraThin = "_2w-3";
export var fillBar = "_2w-6";
export var fillContainer = "_2w-4";
export var overflow = "_2w-8";
export var overflowContainer = "_2w-5";
export var regular = "_2w-7";
export var thick = "_2w-1";
export var thin = "_2w-2";